import Header from "./components/Header";
import Nav from "./components/Nav";
import About from "./components/About";
import Servicios from "./components/Servicios";
import Contact from "./components/Contact";
//import Marketing from "./components/Marketing";
import Proyectos from "./components/Proyectos";
import Footer from "./components/Footer";

function App() {
  return (
    <>
    <Header />
    <Nav />
    <About />
    <Servicios />
    {/*<Marketing />*/}
    <Proyectos />
    <Contact />
    <Footer />
    </>
  );
}

export default App;
